/**
 * One line to Google Analytics, and only when analytics is actually on.
 *
 * Modules\Ads loads gtag.js just for a GA4 ID that an editor has entered, under
 * Consent Mode: in the EU nothing leaves the browser until the reader agrees, and
 * with no ID `window.gtag` never exists — then every call here is a no-op.
 *
 * What we send is behaviour, never content of the page or anything about the
 * person: the event name, the recipe ID and the interface language.
 *
 * @package
 */

/**
 * Report one interaction.
 *
 * @param {string} name   GA4 event name (snake_case, ≤ 40 chars).
 * @param {Object} params Extra parameters; `lang` is added automatically.
 */
export default function track( name, params = {} ) {
	if ( typeof window.gtag !== 'function' ) {
		return;
	}

	try {
		window.gtag( 'event', name, {
			lang: document.documentElement.lang || '',
			...params,
		} );
	} catch {
		// Analytics must never break the page.
	}
}

/**
 * The recipe a control belongs to, for the `recipe_id` parameter.
 *
 * The translation group, not the post: one dish then counts as one recipe in
 * the reports, however many languages it is read in.
 *
 * @param {Element} el Any element inside the recipe page or card.
 * @return {number} Translation group ID, or 0 when there is none.
 */
export function recipeId( el ) {
	const holder =
		el?.closest?.( '[data-recipe]' ) ||
		document.querySelector( '[data-recipe]' );

	return (
		Number( holder?.dataset?.group || holder?.dataset?.recipe || 0 ) || 0
	);
}
